export default [
  {
    name: 'it-issues-board',
    component: () => import('@/modules/ITIssues/pages/Board.vue'),
    path: '/it-issues',
    meta: {
      layout: 'main',
      auth: true,
      // Access is actually controlled by IS_DEVELOPER / IS_IT_SUPPORT flags
      // in storage (checked in the Board component and sidebar). The main
      // role list below just has to pass the router guard — every internal
      // role is allowed through, then the component gates features.
      role: [
        'admin',
        'academy',
        'branchacademy',
        'branchManager',
        'teacher',
        'kurator',
        'tutor',
        'instructor',
        'finance',
        'hr',
        'marketing',
        'audit',
        'axo',
        'bi',
        'call',
        'examiner',
        'metodist',
        'moderator',
      ],
    },
  },
];
